module.exports = __webpack_public_path__ + "static/media/bg-mobile1.206e9182.svg";